module.exports = "/static/assets/1487a79255d36e22aebab81dc4dab2ea.svg";